import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbTokenColorPickerComponent } from 'libs/gb-dashboard/shared/ui/src/lib/gb-token-color-picker/gb-token-color-picker.component'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'
import { GbPresenterToolsAdvancedOptionsContainerComponent } from '../gb-presenter-tools-advanced-options-container/gb-presenter-tools-advanced-options-container.component'

@Component({
  selector: 'gb-presenter-tools-qr-code',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbTokenColorPickerComponent,
    GbPresenterToolsTextComponent,
    GbPresenterToolsAdvancedOptionsContainerComponent,
  ],
  templateUrl: './gb-presenter-tools-qr-code.component.html',
  styleUrl: './gb-presenter-tools-qr-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsQrCodeComponent {
  @Input({ required: true }) toolsFormGroup!: FormGroup

  hideFields = ['font_weight', 'font_style', 'text_align']

  get urlControl(): FormControl {
    return this.toolsFormGroup.get('url') as FormControl
  }

  get hideUrlControl(): FormControl {
    return this.toolsFormGroup.get('hide_url') as FormControl
  }

  get backgroundColorControl(): FormControl {
    return this.toolsFormGroup.get('background_color') as FormControl
  }
}
